/**
 * Retrieves the appropriate internationalization message for a given color
 * @param messages - Record of color values to message descriptors
 * @param color - The color value to look up
 * @returns The message descriptor or undefined if not found
 */
export default function getColorMessage(messages, color) {
  var message = messages[color];
  if (!message) {
    // eslint-disable-next-line no-console
    console.warn("Color palette does not have an internationalization message for color ".concat(color.toUpperCase(), ".\nYou must add a message description to properly translate this color.\nUsing current label as default message.\nThis could have happened when someone changed the 'colorPalette' from 'adf-schema' without updating this file.\n"));
  }
  return message;
}